import { AppState } from '../reducers';
import { createSelector } from 'reselect';

const selectUi = (state: AppState) => state.ui;

export const selectProductDisplay = createSelector(
  selectUi,
  ui => ui.productDisplay
);

export const selectMyClassTab = createSelector(selectUi, ui => ui.myClassTab);

export const selectNavBar = createSelector(selectUi, ui => ui.navBarOpen);
export const selectClasseChoice = createSelector(
  selectUi,
  ui => ui.classeChoiceOpen
);
